import { Checkbox } from '@carbon/react';
import { bucketLabel } from './facet-label';
import type { FacetBucket } from '../types';
import style from './filter-modal.module.scss';

interface BucketCheckboxListProps {
  /** Prefix for each checkbox id (`<idPrefix>-<bucketId>`). */
  idPrefix: string;
  /** Container class for the checkbox list. */
  className: string;
  buckets: FacetBucket[];
  selectedIds: string[];
  /** Text shown when there are no buckets to list. */
  emptyHint: string;
  /** Noun appended after the count, e.g. "Documents" → "Courthouse (19 Documents)". */
  countNoun?: string;
  onToggle: (id: string, checked: boolean) => void;
}

/**
 * Facet buckets rendered as a checkbox list, or an empty hint when there are
 * none. Buckets without a count (options resolved outside the search) show
 * their name alone. The caller owns any search box / Select-All row above it.
 * @param {BucketCheckboxListProps} props The list.
 * @return {JSX.Element} The list.
 */
export function BucketCheckboxList({
  idPrefix,
  className,
  buckets,
  selectedIds,
  emptyHint,
  countNoun,
  onToggle,
}: BucketCheckboxListProps) {
  if (buckets.length === 0) {
    return <p className={style.emptyHint}>{emptyHint}</p>;
  }
  return (
    <div className={className}>
      {buckets.map((bucket) => (
        <Checkbox
          key={bucket.id}
          id={`${idPrefix}-${bucket.id}`}
          labelText={bucketLabel(bucket, countNoun)}
          checked={selectedIds.includes(bucket.id)}
          onChange={(_evt, { checked }: { checked: boolean }) =>
            onToggle(bucket.id, checked)
          }
        />
      ))}
    </div>
  );
}
